import { PageSkeleton } from "#components/pages";

export function DMCAPage() {
  const title = "DMCA Notice";
  const heading = "DMCA Notice";

  return (
    <PageSkeleton name="" title={title} heading={heading}>
      <p>
        Please allow up to 3-5 working days for your request to be processed.
        You may not receive a response unless further information is needed from
        you.
      </p>

      <p>
        This information is required by the DMCA process. If any required
        information is falsified or omitted, your request may be not be
        processed.
      </p>

      <p>
        Notices may be shared to third  parties for due diligence and transparency
        purposes.
      </p>

      <p>
        Please be aware that information that is not protected by copyright may
        not be removed from the site. This includes AI generated content,
        creator tags, creator profiles, wiki pages, links to social media
        profiles or other websites, links to works on other websites, and other
        factual information not protected by copyright law.
      </p>

      <p>
        Please note that we will only honor content removal requests from the
        following parties:
      </p>

      <ul>
        <li>Legal copyright holder of the content</li>
        <li>Legal copyright holder of the character(s)</li>
        <li>The commissioner(s) of the content</li>
      </ul>

      <p>
        Please consult the guide below for further information regarding when
        it's acceptable to submit a takedown request and when it's not.
      </p>

      <p>
        You <strong>SHOULD</strong> submit a takedown request if you are one of
        the following:
      </p>

      <ul>
        <li>Creator wanting their own content removed.</li>
        <li>
          Character owner wanting content featuring their character removed.
        </li>
        <li>A commissioner who has paid for the content in question.</li>
        <li>
          Publisher wanting a publication or excerpts of a publication removed.
        </li>
      </ul>

      <p>
        You <strong>SHOULD NOT</strong> submit a takedown request if you are one
        of the following:
      </p>

      <ul>
        <li>
          User wanting content removed because they believe it breaks a site
          rule. You should instead use the site's Flag For Deletion tool (found
          on every post's page) for each post that you wish to dispute.
        </li>
        <li>
          Friend, relative, or fan of an creator, character owner, or
          commissioner who wishes to act as a middlemen for the creator,
          character owner, or commissioner.
        </li>
        <li>
          Commissioner or character owner wanting to remove art that the creator
          themselves has posted. In those cases please ask the creator to file a
          takedown request for you.
        </li>
      </ul>

      <p>Your email must include the following:</p>

      <ul>
        <li>
          Your contact information, including your name, physical address, phone
          number, and email address.
        </li>
        <li>
          Identification of the material you wish to have removed, with enough
          information to locate the material. For example, a list of links to
          each post on Kemono you wish to have removed. Screenshots or simply
          listing your creator tag, creator name, or social media accounts are
          not sufficient to locate the exact material you wish to have removed.
        </li>
        <li>
          Identification of the copyrighted work you claim is being infringed.
          For example, for each Kemono post you claim infringes on your
          copyright, a link to where the original work was posted on your Pixiv,
          Twitter, or other social media accounts or personal websites.
        </li>
        <li>
          A statement that you have a good faith belief that the use of the work
          you believe is being infringed was not authorized by the copyright
          owner, an agent of the owner, or the law.
        </li>
        <li>
          A statement that everything contained in the takedown notice is
          accurate and that, under penalty of perjury, you are the copyright
          owner or have permission to act on the copyright owner’s behalf.
        </li>
        <li>
          Your signature. This must be your full legal name, not a pseudonym or
          creator handle.
        </li>
      </ul>

      <p>
        This notice can be sent via email to us on our Legal Inquiries address
        found on the <a href="/contact">contact page</a>.
      </p>

      <p>
        <strong>
          Failure to follow these instructions, or emailing it to the wrong
          department, or emailing all three departments at once will get your
          notice discarded.
        </strong>
      </p>

      <p>
        For further assistance, or for any questions regarding takedowns, please{" "}
        <a href="/contact">contact us</a>.
      </p>
    </PageSkeleton>
  );
}
